import { Card, Grid } from "@mui/material";
import CardItem from "components/alove/CardItem";
import ItemPageContainer from "layouts/itemPageContainer";
import { TagRule } from "models/events/TagRule";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { createTagRuleDO, deleteTagRuleDO, getTagRule, saveTagRuleDO, executeTagRuleDO } from "utils/tagRuleUtils";
import { useAuth, useMaterialUIController } from "context";
import { PermissionType } from "models/BO/BoRole";
import { SMEHeader } from "layouts/itemPageContainer/userItem/profileHeader";
import { PageNumber } from "accessNumbers";
import { RuleInfo } from "./components/RuleInfo";
import { TagCondition } from "./components/TagCondition";
import { MatchingProfiles } from "./components/MatchingProfiles";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import { ItemHeader } from "layouts/itemPageContainer/userItem/itemHeader";
import { formatDate } from "utils/globalsUtils";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

export const TagRulesView = () => {
  const pageNumber = PageNumber.ViewInfoScreen;
  const navigate = useNavigate();
  const [controller, dispatch] = useMaterialUIController();
  const { currentRole } = useAuth();
  const [tagRule, setTagRule] = useState({
  } as TagRule);
  const { id } = useParams();

  useEffect(() => {
    if (id && id !== "new") {
      getTagRule(id).then((tagRule) => setTagRuleObject(tagRule));
    }
  }, [id]);

  const setTagRuleObject = (newTagRule) => {
    setTagRule(Object.assign(new TagRule(), newTagRule));
  };

  const saveTagRule = async () =>
    id === "new" ? createTagRuleDO(tagRule).then((tagRule) => navigate(-1)) : saveTagRuleDO(tagRule);

  const deleteTagRule = async () => deleteTagRuleDO(tagRule).then(() => navigate(-1));

  const executeTagRule = async () => {
    if (tagRule.id) {
      await executeTagRuleDO(tagRule.id);
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar pageTitle="Tag Rules" />
      <ItemPageContainer
        navItems={[
          { label: "Rule Information", ref: "ruleInfo" },
          { label: "Tag Conditions", ref: "tagConditions" },
          { label: "Matching Profiles", ref: "matchingProfiles" },
        ]}
        actions={{
          actionsTitle: "Tag Rule actions",
          itemName: `Information`,
          itemNumber: `#${tagRule.id}`,
          actions: [
            {
              title: "Save",
              onClick: saveTagRule,
              variant: "contained",
            },
            {
              title: "Execute",
              onClick: executeTagRule,
              variant: "outlined",
              hidden: !tagRule.id,
            },
          ],
        }}
        itemStatus={tagRule.id ? {
          title: "Rule status",
          item: tagRule,
          isManager: true,
          changeStatus: async (newStatus) => {
            tagRule.statusId = newStatus;
            setTagRuleObject({ ...tagRule });
            await saveTagRule();
          },
        } : undefined}
        itemHeader={tagRule.id ? <ItemHeader
          title="Tag Rule"
          indications={[{
            title: "Key",
            value: tagRule.key
          }, {
            title:"Created",
            value: formatDate(tagRule.created)
          }, {
            title:"Updated",
            value: formatDate(tagRule.updated) 
          }]} /> : undefined}
        deleteItem={{
          buttonText: "Delete TagRule",
          contetnText: "Are you sure you want to delete this tagRule?",
          hidden: !currentRole.hasAccess(pageNumber, PermissionType.Delete),
          onDelete: deleteTagRule,
        }}
      >
        <CardItem title="Rule Information" id="ruleInfo">
          <RuleInfo 
            tagRule={tagRule} 
            onTagRuleChange={setTagRuleObject} 
          />
        </CardItem>
        
        <CardItem title="Tag Conditions" id="tagConditions">
          <TagCondition 
            tagRule={tagRule} 
            onTagRuleChange={setTagRuleObject} 
          />
        </CardItem>
        
        <CardItem title="Matching Profiles" id="matchingProfiles">
          <MatchingProfiles 
            tagRuleKey={tagRule.key} 
          />
        </CardItem>
        
      </ItemPageContainer>
    </DashboardLayout>
  );
};
